import {
  convertUTCDateTimeToLocal,
  toDisplayDateTime,
} from "../blocks/fields/formatDate";

/**
 * Footer summary of who last touched the record. Returns null when the record
 * carries neither value - not every entity's read projects them.
 */
export function getLastModifiedLabel(
  record: Record<string, unknown> | null
): string | null {
  if (!record) {
    return null;
  }

  const by =
    typeof record.modifiedbyname === "string" && record.modifiedbyname.length > 0
      ? record.modifiedbyname
      : null;
  const on = toDisplayDateTime(
    convertUTCDateTimeToLocal(
      record.modifiedon as string | Date | null | undefined
    )?.toDate()
  );

  if (by && on) {
    return `Last modified by ${by} on ${on}`;
  }
  if (by) {
    return `Last modified by ${by}`;
  }
  if (on) {
    return `Last modified on ${on}`;
  }

  return null;
}
